import { useEffect, useState } from "react";
import { useSignedInIdentity } from "./auth";

export function OverviewGreeting() {
  const identity = useSignedInIdentity();
  const [hour, setHour] = useState(() => new Date().getHours());
  useEffect(() => {
    const updateHour = () => setHour(new Date().getHours());
    const timer = window.setInterval(updateHour, 60_000);
    window.addEventListener("focus", updateHour);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", updateHour);
    };
  }, []);

  const givenName = typeof identity?.given_name === "string" ? identity.given_name.trim() : "";
  const firstName = givenName || (typeof identity?.name === "string" ? identity.name.trim().split(/\s+/)[0] : "");
  const greeting = hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  return <h2>{greeting}{firstName ? `, ${firstName}` : ""}</h2>;
}
